export default "__VITE_ASSET__VQGDI44p__"